import { Card, Image, Stack, Text, Box, Group } from "@mantine/core";
import { Link } from "@inertiajs/react";
import type { PostSummary } from "../../types/post";
import { PostTypeBadges } from "./PostTypeBadges";

interface Props {
  post: PostSummary;
  variant?: "default" | "compact";
}

export function PostCard({ post, variant = "default" }: Props) {
  const formatted = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const cardStyle = {
    background: "rgba(20, 20, 28, 0.6)",
    backdropFilter: "blur(8px)",
    borderColor: "rgba(255, 128, 0, 0.12)",
    overflow: "hidden",
    height: "100%",
  };

  if (variant === "compact") {
    return (
      <Link
        href={`/posts/${post.slug}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <Card withBorder radius="md" p={0} style={cardStyle}>
          <Group gap="sm" wrap="nowrap" align="stretch">
            <Box
              style={{
                width: 128,
                flexShrink: 0,
                aspectRatio: "16/9",
                background: "#1a1a2e",
              }}
            >
              {post.cover_image_url && (
                <Image
                  src={post.cover_image_url}
                  alt={post.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            </Box>
            <Stack gap={4} py="xs" pr="sm" style={{ flex: 1, minWidth: 0 }}>
              <PostTypeBadges
                postType={post.post_type}
                podcastNumber={post.podcast_number}
                size="xs"
              />
              <Text fw={600} size="sm" lh={1.3} lineClamp={2}>
                {post.title}
              </Text>
              <Text size="xs" c="dimmed">
                {formatted}
              </Text>
            </Stack>
          </Group>
        </Card>
      </Link>
    );
  }

  return (
    <Link
      href={`/posts/${post.slug}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Card withBorder radius="md" p={0} style={cardStyle}>
        <Box style={{ aspectRatio: "16/9", background: "#1a1a2e" }}>
          {post.cover_image_url && (
            <Image
              src={post.cover_image_url}
              alt={post.title}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
        </Box>
        <Stack gap="xs" p="md">
          <PostTypeBadges
            postType={post.post_type}
            podcastNumber={post.podcast_number}
            size="xs"
          />
          <Text fw={700} lh={1.3} lineClamp={2}>
            {post.title}
          </Text>
          <Text size="xs" c="dimmed">
            {formatted}
          </Text>
        </Stack>
      </Card>
    </Link>
  );
}

export default PostCard;
